import React, { useMemo, useState, useEffect } from "react";

/** needs name and code filled inside row 
 * if url is there then tage will be clickable, else not
*/
function NameCodeRowUI({ row }) {
    if(!row) return (<span></span>);
  return (
     <a
        href={row.url || '#'}
        className="rounded-full  px-1 py-1  transition
        text-center items-center justify-center"
      >
    <span
      className="rounded-full bg-slate-200 
      hover:bg-teal-600 hover:text-white
       px-4 py-1 text-sm text-slate-700
       text-center items-center justify-center"
    >
     
        {row.name}
     
    </span>
     </a>
  );
}

/** Button used for the "+n more" trigger */
function TagsNMoreButton({ n, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="px-3 py-1 text-sm font-medium rounded-full
       bg-slate-600 text-white hover:bg-slate-700 focus:outline-none
        focus:ring-2 focus:ring-offset-2 focus:ring-slate-500"
      aria-label={`Show ${n} more tags`}
    >
      +{n} more
    </button>
  );
}

/** Simple accessible modal */
function TagsListModal({ title = "All Companies", open, onClose, children }) {
  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose();
    }
    if (open) document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50">
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="relative mx-auto mt-24 w-11/12 max-w-3xl rounded-2xl bg-white shadow-xl">
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <h3 className="text-lg font-semibold text-slate-800">{title}</h3>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md px-2 py-1 text-slate-600 
            hover:text-slate-900 hover:bg-slate-100 focus:outline-none
             focus:ring-2 focus:ring-offset-2 focus:ring-slate-500"
            aria-label="Close"
          >
            ✕
          </button>
        </div>
        <div className="p-4">{children}</div>
        <div className="px-4 pb-4">
          <button
            type="button"
            onClick={onClose}
            className="w-full rounded-lg bg-slate-800 text-white py-2
             hover:bg-slate-600 focus:outline-none focus:ring-2 
             focus:ring-offset-2 focus:ring-slate-500"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

/**
 * title: e.g. 14. Design Unix 'find' command for file search
 * tags: Array<{ name: string, code: string, url: String }>
 * - url is the url to visit when tag is clicked
 * Rules:
 * - If 1–2 tags: show on one row
 * - If >=3 tags: show first two on row 1, the 3rd on row 2
 *   - Only show "+n more" if there are >3 total (n = total - 3)
 * Modal lists all tags sorted by name, 4 per row.
 */
function TagsListUI({title="", tags = [] }) {
  const [open, setOpen] = useState(false);

  const total = tags.length;
  const firstRow = total <= 2 ? tags : tags.slice(0, 2);
  const secondRowThird = total >= 3 ? [tags[2]] : [];
  const hiddenCount = total > 3 ? total - 3 : 0;

  const sortedAll = useMemo(
    () => [...tags].sort((a, b) => a.name.localeCompare(b.name)),
    [tags]
  );

    useEffect(() => {
     // console.log("inside tags list ui. tags length "+tags.length);
      // console.log(JSON.stringify(tags))
      
      
  }, []);

  if(!tags) return(<span></span>);
  
  return (
    <>
      {/* Visible preview area */}
      <div className="flex flex-col gap-2">
        {/* Row 1 */}
        <div className="flex flex-row flex-wrap items-center gap-2">
          {firstRow.map((c) => (
            <NameCodeRowUI key={c.code} row={c} />
          ))}
        </div>

        {/* Row 2 (only if >=3) */}
        {total >= 3 && (
          <div className="flex flex-row flex-wrap  gap-2
          ">
            {secondRowThird.map((c) => (
              <NameCodeRowUI key={c.code} row={c} />
            ))}
            {hiddenCount > 0 && (
              <TagsNMoreButton n={hiddenCount} onClick={() => setOpen(true)} />
            )}
          </div>
        )}
      </div>

      {/* Modal for all tags */}
      <TagsListModal open={open} onClose={() => setOpen(false)} title={title}>
        <div className="grid grid-cols-4 gap-6">
          {sortedAll.map((c) => (
            <NameCodeRowUI key={c.name} row={c} />
          ))}
        </div>
      </TagsListModal>
    </>
  );
}

export {TagsListUI}
